import { t as uiText } from '../i18n';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const AccessDenied: React.FC = () => {
  const navigate = useNavigate();
  const [btnHover, setBtnHover] = useState(false);

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '24px',
        fontFamily:
          'system-ui, -apple-system, "Segoe UI", Roboto, "Hiragino Sans", "Noto Sans JP", sans-serif',
        background:
          'linear-gradient(165deg, #f5f0eb 0%, #faf8f5 38%, #f8f9fa 72%, #efe8e0 100%)',
      }}
    >
      <div
        style={{
          textAlign: 'center',
          maxWidth: '480px',
          width: '100%',
          padding: '48px 40px 44px',
          backgroundColor: 'rgba(255, 252, 248, 0.94)',
          borderRadius: '22px',
          border: '1px solid rgba(207, 174, 145, 0.28)',
          boxShadow:
            '0 1px 2px rgba(90, 70, 55, 0.05), 0 20px 50px -18px rgba(90, 70, 55, 0.1)',
          backdropFilter: 'blur(12px)',
        }}
      >
        <div
          style={{
            width: 56,
            height: 56,
            margin: '0 auto 22px',
            borderRadius: '18px',
            background:
              'linear-gradient(145deg, #f5f0eb 0%, rgba(207, 174, 145, 0.35) 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#8b6f52',
          }}
          aria-hidden
        >
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
            <rect x="5" y="11" width="14" height="10" rx="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
        </div>

        <h2
          style={{
            margin: '0 0 12px',
            fontSize: '1.35rem',
            fontWeight: 600,
            letterSpacing: '-0.02em',
            color: '#3d3429',
            lineHeight: 1.35,
          }}
        >
          {uiText("You do not have access")}
        </h2>

        <p
          style={{
            margin: '0 0 18px',
            fontSize: '0.95rem',
            color: '#6b5d52',
            lineHeight: 1.75,
            textAlign: 'left',
          }}
        >
          {uiText("Cannot open this page's project. This can appear when the URL is wrong or the project does not exist. It also appears if your account has not joined this project yet.")}
        </p>

        <div
          role="region"
          aria-label={uiText("What to check if you cannot access")}
          style={{
            margin: '0 0 28px',
            padding: '18px 20px',
            textAlign: 'left',
            backgroundColor: 'rgba(245, 240, 235, 0.55)',
            borderRadius: '14px',
            border: '1px solid rgba(207, 174, 145, 0.22)',
          }}
        >
          <p
            style={{
              margin: '0 0 12px',
              fontSize: '0.8125rem',
              fontWeight: 600,
              letterSpacing: '0.02em',
              color: '#5c4d42',
            }}
          >
            {uiText("Please review the following")}
          </p>
          <ol
            style={{
              margin: 0,
              paddingLeft: '1.35em',
              fontSize: '0.9rem',
              color: '#6b5d52',
              lineHeight: 1.75,
            }}
          >
            <li style={{ marginBottom: '10px' }}>
              {uiText("From \"Back to home\" at the bottom of the screen, go to the top and, for the relevant project, ")}<strong style={{ fontWeight: 600, color: '#5c4d42' }}>{uiText("whether you have joined")}</strong>{uiText("please check.")}
            </li>
            <li>
              {uiText("If it is missing from the list or cannot be opened, access to the project may not have been granted yet. If so, ")}<strong style={{ fontWeight: 600, color: '#5c4d42' }}>{uiText("Ask a project admin for an invite")}</strong>{uiText("Please.")}
            </li>
          </ol>
        </div>

        <button
          type="button"
          onClick={() => navigate('/')}
          onMouseEnter={() => setBtnHover(true)}
          onMouseLeave={() => setBtnHover(false)}
          style={{
            padding: '13px 28px',
            backgroundColor: btnHover ? '#b89672' : '#cfae91',
            color: '#fff',
            border: 'none',
            borderRadius: '999px',
            cursor: 'pointer',
            fontSize: '0.9375rem',
            fontWeight: 500,
            letterSpacing: '0.01em',
            boxShadow: btnHover
              ? '0 4px 14px rgba(139, 111, 78, 0.32)'
              : '0 2px 10px rgba(139, 111, 78, 0.2)',
            transition: 'background-color 0.2s ease, box-shadow 0.2s ease, transform 0.15s ease',
            transform: btnHover ? 'translateY(-1px)' : 'translateY(0)',
          }}
        >
          {uiText("Back to home")}
        </button>
      </div>
    </div>
  );
};

export default AccessDenied;
